import {
  Component,
  Input,
  OnChanges,
  OnInit,
} from '@angular/core';
import {
  AbstractControl,
  NG_VALIDATORS,
  NG_VALUE_ACCESSOR,
  ValidationErrors,
} from '@angular/forms';
import { CustomSelectOption } from 'src/app/core/interfaces/custom-select-option';
import { Warehouse } from 'src/app/core/models/warehouse';
import { WarehouseService } from 'src/app/core/services/general/warehouse.service';

@Component({
  selector: 'app-warehouse-input',
  templateUrl: './warehouse-input.component.html',
  styleUrls: ['./warehouse-input.component.scss'],
  providers: [
    {
      provide: NG_VALUE_ACCESSOR,
      multi: true,
      useExisting: WarehouseInputComponent,
    },
    {
      provide: NG_VALIDATORS,
      multi: true,
      useExisting: WarehouseInputComponent,
    },
  ],
})
export class WarehouseInputComponent implements OnInit, OnChanges {
  @Input()
  title = "Select Warehouse...";

  @Input()
  isDisabled = false;


  @Input()
  filterCommodityUuid = null;


  public value?: string;
  public localValue?: CustomSelectOption;

  public warehousesList: Array<CustomSelectOption> = [];
  public warehouses: Array<Warehouse> = [];

  // The list actually bound to <app-custom-select>. It is a STABLE property, recomputed only when the
  // data loads or when filterCommodityUuid changes — never a template method. Binding a method
  // (getFilteredList()) handed the select a brand-new array on every change-detection tick, so the
  // options it snapshots on open could be stale/empty until another page had already warmed the fetch.
  // Every other *-input dropdown binds a plain property this way, which is why they behave smoothly.
  public filteredWarehousesList: Array<CustomSelectOption> = [];


  constructor(
    private warehouseService: WarehouseService,
  ) { }

  ngOnInit(): void {
    this.warehouseService
      .all()
      .subscribe((res: Array<Warehouse>) => {

        this.warehouses = res.map((el) => {
          return new Warehouse(el);
        });


        this.warehousesList = res.map((el) => {
          return {
            name: `${el.name}`,
            value: el.uuid,
          }
        });
        this.recomputeFilteredList();
        this.writeValue(this.value);
      });
  }

  ngOnChanges(): void {
    // filterCommodityUuid is often bound to a form control and arrives/changes after construction.
    this.recomputeFilteredList();
  }

  private recomputeFilteredList(): void {
    const list = this.warehouses.filter((el) => {
      if (this.filterCommodityUuid) {
        return el.commodity_warehouses?.find((cw) => cw.commodity_uuid == this.filterCommodityUuid);
      }
      return true;
    });

    this.filteredWarehousesList = this.warehousesList.filter((el) => list.find((p) => p.uuid == el.value));
  }


  onChange = (val: string | undefined) => {
  };

  onTouched = () => { };

  touched = false;
  disabled = false;

  writeValue(val?: string) {
    this.value = val;
    if (this.value != undefined || this.value != null) {
      this.localValue = this.warehousesList.filter((el) => el.value == val)[0];
    }
  }

  onValueChange(val?: CustomSelectOption) {
    this.value = val?.value;
    this.onChange(this.value);
    this.writeValue(this.value);
  }


  registerOnChange(onChange: any) {
    this.onChange = onChange;
  }

  registerOnTouched(onTouched: any) {
    this.onTouched = onTouched;
  }

  markAsTouched() {
    if (!this.touched) {
      this.onTouched();
      this.touched = true;
    }
  }

  setDisabledState(disabled: boolean) {
    this.disabled = disabled;
  }

  validate(control: AbstractControl): ValidationErrors | null {
    return null;
  }
}
